import { useTranslation } from 'react-i18next'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import cx from 'classnames'

import { concealEmail } from '../EmailSetting/helpers'

import { Input } from 'components'
import Button from 'components/Button'

import '../style.scss'

type Props = {
  currentEmail?: string
  mode?: 'changeEmail'
  detailText?: string
  email: string
  onNext: (email: string) => void
}

export const EmailForm = ({
  currentEmail,
  mode,
  detailText,
  email,
  onNext,
}: Props) => {
  const { t } = useTranslation()

  const hideInput = currentEmail && mode !== 'changeEmail'

  const formik = useFormik({
    initialValues: { email: hideInput ? currentEmail : email },
    validationSchema: Yup.object().shape({
      email: Yup.string().required(t('common.validation.required')),
    }),
    onSubmit: ({ email }) => {
      onNext(hideInput ? currentEmail : email)
    },
    enableReinitialize: true,
  })

  return (
    <>
      {currentEmail && (
        <div className="UserSetting__header">
          <h3 className="UserSetting__h3">
            {t('user_setting.email_form.current_email')}
          </h3>

          <p className="UserSetting__p">{concealEmail(currentEmail)}</p>
        </div>
      )}

      <form className="UserSetting__form" onSubmit={formik.handleSubmit}>
        <Input
          className={cx('UserSetting__form__input', {
            'UserSetting__form__input--hidden': hideInput,
          })}
          label={
            mode === 'changeEmail'
              ? t('user_setting.email_form.change_email.label')
              : t('user_setting.email_form.email.label')
          }
          placeholder={
            mode === 'changeEmail'
              ? t('user_setting.email_form.change_email.placeholder')
              : t('common.email_address')
          }
          type="email"
          name="email"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.email}
          error={formik.touched.email && formik.errors.email}
          autoFocus
        />

        {detailText && <p className="UserSetting__p">{detailText}</p>}

        <Button
          className="UserSetting__form__submit"
          size="medium"
          type="submit"
        >
          {t('common.next')}
        </Button>
      </form>
    </>
  )
}
